import { useNavigate, Navigate } from 'react-router-dom';
import { ClockIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../../core/providers/AuthProvider';
import { useOfficerApproval } from '../hooks/useOfficerApproval';
import Spinner from '../../../shared/components/Spinner';

function PendingApprovalPage() {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const { approved, loading } = useOfficerApproval(true);

  const handleBackToHome = async () => {
    await signOut();
    navigate('/');
  };

  if (loading) {
    return <Spinner />;
  }

  if (approved) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="h-dvh flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm bg-white rounded-lg border border-gray-200 p-8 space-y-4 text-center">
        <div className="flex justify-center">
          <ClockIcon className="h-12 w-12 text-amber-500" />
        </div>

        <h1 className="text-xl font-semibold text-gray-900">Pending Approval</h1>

        <p className="text-sm text-gray-500">
          Your profile has been submitted successfully. Your account is now subject to admin
          approval before you can access the dashboard. You'll be notified once an administrator
          reviews your account.
        </p>

        <button
          type="button"
          onClick={handleBackToHome}
          className="w-full bg-[#3f6d8e] text-white rounded-md py-4 text-sm font-medium hover:bg-[#122436]"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default PendingApprovalPage;
